import { handleRequestMessage } from './handle-message.js';
import { postSafe } from './post-message.js';
import type { SymbolIndexWorkerPort } from './protocol.js';

export function attachSymbolIndexWorkerHost(port: SymbolIndexWorkerPort): void {
  port.onMessage((message) => {
    void handleRequestMessage(port, message);
  });
  postSafe(port, { type: 'ready' });
}
